/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Create_FirstInputs */

const en_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first resume`)
};

const de_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deinen ersten Lebenslauf erstellen`)
};

const fr_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer ton premier CV`)
};

const es_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear su primer currículum`)
};

const it_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea il tuo primo curriculum`)
};

const nl_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak je eerste CV`)
};

const pl_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz swoje pierwsze CV`)
};

const fi_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo ensimmäinen ansioluettelosi`)
};

const da_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret dit første CV`)
};

const sv_resumes_create_first = /** @type {(inputs: Resumes_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa ditt första CV`)
};

/**
* | output |
* | --- |
* | "Create your first resume" |
*
* @param {Resumes_Create_FirstInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_create_first = /** @type {((inputs?: Resumes_Create_FirstInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Create_FirstInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_create_first(inputs)
	if (locale === "fr") return fr_resumes_create_first(inputs)
	if (locale === "es") return es_resumes_create_first(inputs)
	if (locale === "it") return it_resumes_create_first(inputs)
	if (locale === "nl") return nl_resumes_create_first(inputs)
	if (locale === "pl") return pl_resumes_create_first(inputs)
	if (locale === "fi") return fi_resumes_create_first(inputs)
	if (locale === "da") return da_resumes_create_first(inputs)
	if (locale === "sv") return sv_resumes_create_first(inputs)
	return en_resumes_create_first(inputs)
});